module.exports = __webpack_public_path__ + "img/logo_iap.b4214424.png";